var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRootSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9744 5.71154C13.0908 5.43205 13.3639 5.25 13.6667 5.25H22C22.4142 5.25 22.75 5.58579 22.75 6C22.75 6.41421 22.4142 6.75 22 6.75H14.1667L9.35897 18.2885C9.26202 18.5212 9.05466 18.6896 8.80703 18.7367C8.5594 18.7839 8.30464 18.7035 8.12892 18.5228L3.66667 13.9331L2.53775 15.0942C2.24901 15.3912 1.77418 15.3979 1.47719 15.1092C1.1802 14.8204 1.17351 14.3456 1.46225 14.0486L3.12892 12.3343C3.27013 12.1891 3.46409 12.1071 3.66667 12.1071C3.86924 12.1071 4.0632 12.1891 4.20441 12.3343L8.41173 16.6619L12.9744 5.71154Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRootSign);
export default __webpack_public_path__ + "static/media/root-sign.7c026f5f49abc043d22e63e0c63c3170.svg";
export { ForwardRef as ReactComponent };